import * as React from 'react';
import { Builder } from '@builder.io/react';

export const register = <TProps>(Component: React.FC<TProps>): void => {
	Builder.registerComponent(Component, {
		name: 'JourneysMarketingForms',
		override: true,
		inputs: [
			{
				name: 'html',
				type: 'html',
				defaultValue: `<div data-form-id='{msdynmkt_marketingformid}' data-form-api-url='https://{server}.dynamics.com/api/v1.0/orgs/{organizationid}/landingpageforms/forms/{msdynmkt_marketingformid}' data-cached-form-url='https://{server}.dynamics.com/{organizationid}/digitalassets/forms/{msdynmkt_marketingformid}'></div>`,
				helperText:
					'Replace {msdynmkt_marketingformid} with the actual identifier of the marketing form entity and {organizationid} with the actual identifier of your organization. {server-} should point to the server endpoints for your organization. The easiest way to grab the information you need is with the "Get Javascript Code" command from the form publish options. ',
				code: true,
			},
			{
				name: 'formLoaderScriptUrl',
				type: 'string',
				defaultValue:
					'https://cxppusa1formui01cdnsa01-endpoint.azureedge.net/eur/FormLoader/FormLoader.bundle.js',
				helperText:
					'And a form loader, which lights up the form placeholders once the page is loaded (a DOMContentLoaded event is triggered).',
			},
			{
				name: 'inverse',
				type: 'boolean',
				defaultValue: false,
				helperText: 'Use this when placing the form on a dark background.',
			},
		],
	});
};

export default register;
